import React from 'react'
import { Redirect } from 'react-router-dom'
import { FuseLoadable } from '@fuse'

export const TasksConfig = {
  settings: {
    layout: {}
  },
  routes: [
    {
      path: '/tasks/lista/nuovaProduzione',
      component: FuseLoadable({
        loader: () => import('./ListaNuovaProduzione')
      })
    },
    {
      path: '/tasks/:boardId',
      component: FuseLoadable({
        loader: () => import('./Board')
      })
    }
  ]
}
